const companyBusinessTypes = ['Agency', 'Brand', 'Freelancer', 'SME', 'Start-up', 'Large Enterprise'];

export default companyBusinessTypes;
